import React from 'react';
import {
  InnerNavigator,
  InnerNavigatorOption,
} from 'components/ui/InnerNavigator';
import { useOrder } from 'hooks/api/scheduling/useOrder';
import { useQuery } from '@tanstack/react-query';

interface Props extends React.PropsWithChildren<{}> {}

export const SchedulingLayout: React.FC<Props> = ({ children }) => {
  const { getOrders } = useOrder();

  const { data: pendingOrders } = useQuery({
    queryKey: ['pendingOrdersCount'],
    queryFn: () =>
      getOrders({
        formFilter: [],
        statusFilter: ['pendente'],
      }),
  });

  const pendingCount = pendingOrders?.length ?? 0;

  const navigatorOptions: InnerNavigatorOption[] = [
    {
      title: 'Calendário',
      route: '/agendamento/calendario',
      hasPermission: true,
    },
    {
      title: 'Solicitações de carregamento',
      route: '/agendamento/solicitacoes/carregamento',
      hasPermission: true,
    },
    {
      title: 'Solicitações de descarregamento',
      route: '/agendamento/solicitacoes/descarregamento',
      hasPermission: true,
    },
    {
      title: `Solicitações pendentes${
        pendingCount > 0 ? ` (${pendingCount})` : ''
      }`,
      route: '/agendamento/solicitacoes-pendentes',
      hasPermission: true,
    },
    {
      title: 'Solicitações reprovadas',
      route: '/agendamento/solicitacoes-reprovadas',
      hasPermission: true,
    },
    {
      title: 'Nova solicitação de estoque',
      route: '/agendamento/criar-solicitacao-estoque',
      hasPermission: true,
    },
  ];

  return (
    <>
      <InnerNavigator options={navigatorOptions} className="mb-[14px]" />
      {children}
    </>
  );
};
